<NavbarSection />

  <!-- HERO / HEADER (full width background) -->
  <div class="bg-primary text-center pricing-m py-5">
    <p class="fw-bold rounded-pill bg-warning text-white mb-2 px-3 py-1 d-inline-block text-xs">Pricing Plans</p>
    <p class="fs-1 fw-semibold mb-2 text-dark">Choose the Right Plan for Your Business</p>
    <p class="fw-light text-dark mb-0 text-xs">
      Transparent pricing with no hidden fees. Start free and scale as you grow.
    </p>
  </div>

  <!-- PRICING CONTENT (constrained width) -->
  <div class="container py-5">

    <!-- Pricing Plans Grid -->
    <div class="row g-4 justify-content-center">

      <div
        v-for="plan in pricing_plans"
        :key="plan.id"
        class="col-12 col-md-6 col-lg-3"
      >
        <div
          class="card h-100 shadow-sm rounded-4 position-relative text-center"
          :class="{ 'pricing-highlight': plan.highlighted }"
        >

          <!-- Most Popular Badge -->
          <div v-if="plan.highlighted" class="pricing-badge">
            <span class="badge rounded-pill bg-warning text-dark px-3 py-1 small fw-semibold">
              Most Popular
            </span>
          </div>

          <div class="card-body p-4 d-flex flex-column">

            <!-- Icon -->
            <div class="pricing-icon d-flex align-items-center justify-content-center mb-3 mb-3">
              <i :class="plan.icon" class="fs-4"></i>
            </div>

            <!-- Plan Name -->
            <h4 class="fw-bold mb-1">{{ plan.name }}</h4>

            <!-- Tagline -->
            <p class="text-muted small mb-3">{{ plan.tagline }}</p>

            <!-- Price -->
            <div class="pricing-price mb-4">
              <span class="pricing-amount">{{ plan.price }}</span>
              <span v-if="plan.period" class="text-muted small">
                {{ plan.period }}
              </span>
            </div>

            <!-- Features -->
            <ul class="list-unstyled text-start small mb-4">
              <li
                v-for="(feature, index) in plan.features"
                :key="index"
                class="d-flex align-items-start mb-2"
              >
                <i class="bi bi-check-circle-fill text-success me-2 mt-1"></i>
                <span>{{ feature }}</span>
              </li>
            </ul>

            <!-- Button -->
            <div class="mt-auto">
              <router-link
                v-if="$router"
                :to="plan.button_link"
                class="btn w-100 rounded-3 fw-semibold py-2"
                :class="plan.highlighted ? 'btn-warning text-dark' : 'btn-outline-secondary'"
              >
                {{ plan.button_text }}
              </router-link>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>

  <!-- FAQ CTA -->
  <div class="container text-center pb-5">
    <h5 class="fw-semibold mb-2">Have Questions?</h5>
    <p class="text-muted mb-3">
      Our team is here to help you choose the right plan for your B-BBEE compliance needs.
    </p>
    <router-link to="/login" class="btn btn-outline-primary px-4 py-2 fs-6 fw-medium mb-4">View FAQ</router-link>
  </div>
<FooterSection />
